<template>
  <div class="wallet-page" v-if="isLogin || true">
    <top-header></top-header>
    <div class="content">
      <left-side></left-side>
      <div class="right-part">
        <top-banner class="banner"></top-banner>
        <back-home></back-home>
        <div class="section">
          <p class="name">
            {{ getCoinsName
            }}<em
              class="ico iconfont icon-wenhao j-ask-wallet"
              @click="visibleCoinsAgreePopupHandle(true)"
            ></em>
          </p>
          <div class="box wallet-balance">
            <div class="info">
              <p class="info-info">{{ letter.curBalance }}</p>
              <p class="info-num">
                {{ curCoinAmount }}
                <span class="currency">{{ curCoinCurrency }}</span>
              </p>
            </div>
            <div class="btn-wrap">
              <div
                class="btn-item wallet-change"
                v-if="showChangeCoinBtn"
                @click="changeCoinType"
              >
                {{ letter.changeCoin }}
              </div>
            </div>
          </div>
        </div>
        <div class="section" v-if="isOpenCoupon">
          <p class="name">
            {{ letter.couponMyQuan }}
          </p>
          <div class="box wallet-balance">
            <div class="info">
              <p class="info-info">{{ letter.voucherCouponTotal }}</p>
              <p class="info-num">
                {{ gameCouponEnableList.length }}
              </p>
            </div>
            <div class="btn-wrap">
              <div
                class="btn-item look-detail j-click-my-coupon"
                @click="refreshGameCoupon"
              >
                {{ letter.storeLookDetail }}
              </div>
              <div
                class="btn-item j-click-vip-score"
                @click="goToVipActivityPage"
                v-if="isOpenVip"
              >
                {{ letter.getMore }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <coins-selector
      class="area-selector"
      v-if="showCoinsSelector"
      :showChildSelector="showCoinsSelector"
      :curBalanceItem="{
        amount: curCoinAmount,
        currency: curCoinCurrency
      }"
      :balanceList="balanceList"
      @closeSelecter="showCoinsSelector = false"
      @hideCoinsSelector="hideCoinsSelector"
    ></coins-selector>
    <transition name="fade" mode="out-in">
      <Loading v-show="loading"></Loading>
    </transition>
    <coins-agree-popup
      v-bind:visible.sync="visibleCoinsAgreePopup"
    ></coins-agree-popup>
    <transition name="fade" mode="out-in">
      <coupon-list-popup
        v-if="isShowGameCouponPopup"
        popupType="game"
        :enableCouponList="gameCouponEnableList"
        :disableCouponList="gameCouponDisableList"
        :expireCouponList="gameCouponExpireList"
        :activeId="gameActiveCouponId"
        :showItemUseBtn="false"
        @closeCouponPopup="hideGameCouponPopup"
        :isPopup="true"
      ></coupon-list-popup>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import coupon from '@mixins/officialWebStore/coupon';
import coinsAgree from '@mixins/officialWebStore/coinsAgree';
import TopBanner from '@components/officialWebStore/TopBanner.vue';
import TopHeader from '@components/officialWebStore/TopHeader.vue';
import CoinsAgreePopup from '@components/officialWebStore/coins/CoinsAgreePopup.vue';
import Loading from '@components/officialWebStore/Loading.vue';
import CoinsSelector from '@components/officialWebStore/coins/CoinsSelector';
import LeftSide from '@components/officialWebStore/LeftSide.vue';
import BackHome from '@components/officialWebStore/BackHome.vue';
import CouponListPopup from '@components/officialWebStore/coupon/CouponListPopup.vue';
import { getLocaLclStor } from '@store/officialWebStore/storager';
import {
  GET_BALANCE_USER_DATA,
  UPDATE_COIN,
  UPDATE_DEFAULT_CURRENCY
} from '@store/officialWebStore/coins';
export default {
  name: 'Wallet',
  mixins: [coupon, coinsAgree],
  data() {
    return {
      showCoinsSelector: false,
      locations: getLocaLclStor()
    };
  },
  computed: {
    ...mapState({
      loading: state => state.loading,
      isLogin: state => state.login.isLogin,
      isUidLogin: state => state.login.isUidLogin,
      gameId: state => state.gameId,
      letter: state => state.letter,
      isShowGameCouponEntry: state => state.coupon.isShowGameCouponEntry,
      hasLoadPaytype: state => state.hasLoadPaytype,
      isUidTypeAndHideVipCoupon: state => state.login.isUidTypeAndHideVipCoupon,
      curCoinAmount: state => state.coins.curCoinAmount,
      curCoinCurrency: state => state.coins.curCoinCurrency,
      balanceList: state => state.coins.balanceList,
      lang: state => state.lang,
    }),
    ...mapGetters(['getCoinsName', 'gameInfoConfig']),
    isOpenCoupon() {
      if(+this.gameId === 274 && this.lang === 'vi-VN') {
        return false;
      }
      return this.gameInfoConfig?.loginCenter?.isOpenCoupon || false;
    },
    isOpenVip() {
      if(+this.gameId === 274 && this.lang === 'vi-VN') {
        return false;
      }
      return this.gameInfoConfig?.loginCenter?.isOpenVip || false;
    },
    showChangeCoinBtn() {
      return this.balanceList.length && this.balanceList.length >= 2;
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(newVal) {
        // 每次进入钱包页面都更新一下数据
        newVal.name === 'wallet' && this.init();
      }
    }
  },
  methods: {
    init() {
      this.isOpenCoupon && this.loadGameCouponList();
      this.loadBalanceUserData();
    },
    async loadBalanceUserData() {
      await this.$store.dispatch(GET_BALANCE_USER_DATA);
    },
    goToVipActivityPage() {
      this.$router.push({
        name: 'vipScore'
      });
    },
    changeCoinType() {
      this.showCoinsSelector = true;
    },
    hideCoinsSelector(balanceItem) {
      this.$store.commit(UPDATE_COIN, {
        amount: balanceItem?.amount,
        currency: balanceItem?.currency
      });
      this.$store.commit(UPDATE_DEFAULT_CURRENCY, balanceItem?.currency);
      this.showCoinsSelector = false;
    }
  },
  components: {
    TopBanner,
    TopHeader,
    CoinsAgreePopup,
    Loading,
    CoinsSelector,
    LeftSide,
    BackHome,
    CouponListPopup
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/officialWebStore.scss';
.wallet-page {
  position: relative;
  float: left;
  display: block;
  width: 100%;
  height: auto;
  min-height: 100%;
  background-color: $bg;
}

.content {
  position: relative;
  margin-bottom: 200px;
  .right-part {
    .banner {
      display: block;
    }
  }
}

.section {
  color: #333;
  margin: 28px auto;
  background: #fff;
  width: 710px;
  border-radius: 9px;
  box-shadow: 0px 10px 10px 0px #e7e7e7;
}

.name {
  position: relative;
  margin: 0 auto;
  font-size: 26px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 81px;
  padding: 30px 20px;
  box-sizing: border-box;
  .icon-wenhao {
    font-size: 35px;
    cursor: pointer;
  }
}
.box {
  background: $lightBg;
  border-bottom-left-radius: 9px;
  border-bottom-right-radius: 9px;
}

.info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 81px;
  padding: 30px 20px;
  box-sizing: border-box;

  &-num {
    font-size: 26px;
    font-weight: bold;
    color: $btnBg;
  }
  &-info {
    font-size: 22px;
  }
}

.btn-wrap {
  display: flex;
  padding: 0 20px 30px;
  .btn-item {
    @include g-border(2px);
    background: #fff;
    border-radius: 40px;
    padding: 10px 20px;
    color: #333;
    font-size: 22px;
    cursor: pointer;
  }
}

.currency {
  margin-left: 2px;
}

.wallet-change,
.look-detail {
  margin-right: 30px;
}

@media screen and (orientation: landscape) {
  .content {
    display: flex;
    justify-content: space-between;
    width: 1300px;
    margin: 21px auto;

    .right-part {
      width: 898px;
      .banner {
        display: none;
      }
      .section {
        width: 100%;
        .name {
          font-size: 22px;
        }
        .info {
          &-info {
            font-size: 16px;
          }
          &-num {
            font-size: 22px;
          }
        }
        .btn-wrap .btn-item {
          font-size: 16px;
        }
      }

      .back {
        margin: 0;
        font-size: 16px;
        cursor: pointer;
        ::v-deep .back-ico {
          width: 9px;
          height: 16px;
          background-size: cover;
        }
      }
    }
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
  .content {
    widows: 1200px;
  }
}
</style>
